<div class="register__informations">
  <ng-container *ngIf="isSocialRegistration; else regularRegistration">
    <p class="register__informations__title" i18n="@@REGISTER_MODAL.NEEDS_INFORMATIONS_VALIDATION_ACCOUNT_SOCIAL_LOGIN">
      Thanks! Last step: Please accept our privacy policy and let us know if you'd like to receive our newsletter.
    </p>
  </ng-container>
  <ng-template #regularRegistration>
    <p class="register__informations__title" i18n="@@REGISTER_MODAL.NEEDS_INFORMATIONS_VALIDATION_ACCOUNT">
      We need a few more details from you to validate your account.
    </p>
  </ng-template>

  <form
    novalidate
    [formGroup]="registerForm"
    [ngClass]="{hasLoader: pending$ | async}"
    id="form-register"
    (ngSubmit)="onSubmit()"
  >
    <div *ngIf="error" class="vc-form__error" aria-live="assertive">{{ error }}</div>

    <!-- PASSWORD -->
    <div *ngIf="!isSocialRegistration" class="vc-form-text register__field">
      <input
        type="password"
        name="password"
        id="user_password"
        class="vc-form-text__input"
        formControlName="password"
        autocomplete="false"
        required
        [attr.type]="displayPassword ? 'text' : 'password'"
      />

      <label class="vc-form-text__label" for="user_password">
        <div *ngIf="password.errors && password.dirty" aria-live="assertive">
          <span *ngIf="password?.errors.required" i18n="@@REGISTER_MODAL.ERROR_REQUIRED_PASSWORD"
            >Password is required</span
          >
        </div>
        <span *ngIf="password.valid || !password.dirty"
          ><ng-container i18n="@@REGISTER_MODAL.PASSWORD">Password</ng-container>*</span
        >
      </label>

      <button aria-live="polite" class="vc-form-text__action" (click)="togglePassword()">
        <ng-container *ngIf="!displayPassword; else hideMsg" i18n="@@REGISTER_MODAL.SHOW_PASSWORD_INPUT"
          >Show</ng-container
        >
        <ng-template #hideMsg i18n="@@REGISTER_MODAL.HIDE_PASSWORD_INPUT">Hide</ng-template>
      </button>
    </div>
    <!-- END PASSWORD -->

    <!-- FIRSTNAME -->
    <div class="register__firstnameInput register__field vc-form-text">
      <input
        class="vc-form-text__input"
        [ngClass]="{notEmpty: credentialFirstname}"
        name="first-name"
        id="first-name"
        type="text"
        formControlName="firstname"
        required
        autocomplete="on"
      />
      <label class="vc-form-text__label" for="first-name">
        <div *ngIf="firstname.errors && firstname.dirty" aria-live="assertive">
          <span *ngIf="firstname.errors.required" i18n="@@REGISTER_MODAL.ERROR_REQUIRED_FIRSTNAME"
            >Firstname is required</span
          >
        </div>
        <span *ngIf="firstname.valid || !firstname.dirty"
          ><ng-container i18n="@@REGISTER_MODAL.FIRSTNAME">Firstname</ng-container>*</span
        >
      </label>
    </div>
    <!-- END FIRSTNAME -->

    <!-- EMAIL (social login) -->
    <div *ngIf="isSocialRegistration" class="register__field">
      <div class="vc-form-text">
        <input
          class="vc-form-text__input"
          [ngClass]="{notEmpty: credentials.email !== ''}"
          name="user_email"
          id="user_email"
          type="email"
          formControlName="email"
        />
        <label class="vc-form-text__label" for="user_email" i18n="@@REGISTER_MODAL.EMAIL">Email<span>*</span> </label>
      </div>
    </div>
    <!-- END EMAIL -->

    <p class="register__requiredFieldMention">
      <ng-container i18n="@@REGISTER_MODAL.MANDATORY_FIELD">* Required field</ng-container>*
    </p>

    <div class="register__cgu">
      <div class="register__cgu__field">
        <input
          class="vc-checkbox__input"
          name="cgv"
          id="registrationCgv"
          type="checkbox"
          autocomplete="off"
          required
          [attr.checked]="cgv?.value"
          formControlName="cgv"
        />
        <label
          class="vc-checkbox__label register__cgu__label"
          for="registrationCgv"
          [ngClass]="{'register__cgu__label--error': !cgv.pristine && cgv.errors && cgv.errors.required}"
        >
          <div i18n="@@RGPD_REGISTER_MODAL.ACCEPT_LEGAL_CHECKBOX">
            By signing up, I accept Vestiaire Collective's
            <a
              i18n-href="@@RGPD_REGISTER_MODAL.ACCEPT_LEGAL_CHECKBOX.TERM_CONDITION.LINK"
              href="https://us.vestiairecollective.com/cgu2.shtml"
              target="_blank"
              rel="noopener"
              >Terms and Conditions</a
            >
            and
            <a
              i18n-href="@@RGPD_REGISTER_MODAL.ACCEPT_LEGAL_CHECKBOX.PRIVACY_POLICY.LINK"
              href="https://us.vestiairecollective.com/privacy-policy/"
              target="_blank"
              rel="noopener"
              >Privacy Policy</a
            >
          </div>
        </label>
      </div>
      <div class="register__cgu__field">
        <input
          class="vc-checkbox__input"
          formControlName="opted"
          id="user_optin"
          type="checkbox"
          autocomplete="off"
          [attr.checked]="opted.value"
          [formControl]="registerCgu"
        />
        <label
          class="vc-checkbox__label register__cgu__label"
          for="user_optin"
          i18n="@@REGISTER_MODAL.RECEIVE_OFFERS_NEWS_CHECKBOX"
          >Sign up for personalised edits, exclusive offers and all the latest news from us. You can opt-out at any
          time.
        </label>
      </div>
    </div>
    <button
      class="vc-btn vc-btn--large vc-btn--full vc-btn--primary"
      type="submit"
      [disabled]="!registerForm.valid"
      i18n="@@REGISTER_MODAL.JOIN_COMMUNITY_BUTTON"
    >
      Join the community
    </button>
  </form>
</div>
